export default {
  overlayLabelMobile: {
    id: 'product_page_out_of_stock_label_mobile',
    defaultMessage: "Darn, it's out of stock <br />(for now)",
  },
  overlayLabelDesktop: {
    id: 'product_page_out_of_stock_label_desktop',
    defaultMessage: 'Out of stock',
  },
  warningMessage: {
    id: 'product_page_out_of_stock_warning_message',
    defaultMessage: 'We found something similar!',
  },
  unavailableLabel: {
    id: 'product_page_out_of_stock_unavailable_label',
    defaultMessage: 'is currently unavailable.',
  },
  cta: {
    id: 'product_page_out_of_stock_cta',
    defaultMessage: 'Take a look at it',
  },
  recommendedProductTag: {
    id: 'product_page_out_of_stock_recommended_product_tag',
    defaultMessage: 'Best alternative',
  },
  recommendedProductPriceFrom: {
    id: 'product_page_out_of_stock_recommended_product_price_from',
    defaultMessage: 'Starting from',
  },
  recommendedProductPriceStriked: {
    id: 'product_page_out_of_stock_recommended_product_price_striked',
    defaultMessage:
      "Crossed out prices may be the manufacturer's suggested retail price, or may be calculated from the average price of the product from different retail distributors.",
  },
}
